import { EditCommandStore } from "./EditCommandStore"; 
import { ISourceReferable } from "./ISourceReferable";
import { SourceReader } from "./SourceReader";

export class EditSourceCommandStore<TSource> extends EditCommandStore<TSource> implements ISourceReferable<TSource> {
  constructor(source: TSource | EditSourceCommandStore<TSource>) {
    super((source instanceof EditSourceCommandStore) ? source : []);
    this._source = (source instanceof EditSourceCommandStore)
      ? source._source
      : new SourceReader(source);
  }

  private readonly _source: SourceReader<TSource>;

  public getSource(): TSource {
    return this._source.getSource();
  }

  public isReferedSameSource(instance: ISourceReferable<TSource>): boolean {
    return (this.getSource() === instance.getSource());
  }

  protected get<T>(get: (s: TSource) => T): T {
    return this._source.get(get);
  }

  protected getOrDefault<T>(get: (s: TSource) => T, defaultValue: T): T {
    return this._source.getOrDefault(get, defaultValue);
  }
}
